import { useEffect } from 'react'
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import './App.css'
import Header from './components/Header/Header'
import Modal from './components/Modal/Modal'
import PhotoItem from './components/Photo/PhotoItem/PhotoItem'
import { useAppDispatch, useAppSelector } from './hooks/store'
import CollectionPage from './pages/collection/Collection'
import HomePage from './pages/home/HomePage'
import PhotoPage from './pages/photo/Photo'
import SearchPage from './pages/search/Search'
import TopicPage from './pages/topic/Topic'
import { fetchTopicList } from './store/thunk/topic'

// FIXME: Fetch next page / infinite scroll
// FIXME: Auto-close keyboard on mobile
function App() {
  const dispatch = useAppDispatch()
  const { topicList } = useAppSelector((state) => state.topicSlice)

  useEffect(() => {
    if (!topicList.length) dispatch(fetchTopicList())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const location = useLocation()
  let previousLocation = location.state?.previousLocation

  return (
    <div className="App">
      <Header />

      <Routes location={previousLocation || location}>
        <Route path="/">
          <Route index element={<HomePage />} />
        </Route>

        <Route path="/photos/:id" element={<PhotoPage />} />

        <Route path="/s">
          <Route index element={<Navigate to="/" />} />
          <Route path="photos/:id" element={<SearchPage type="PHOTOS" />} />
          <Route path="collections/:id" element={<SearchPage type="COLLECTIONS" />} />
          <Route path="users/:id" element={<SearchPage type="USERS" />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Route>

        <Route path="/t">
          <Route index element={<Navigate to="/" />} />
          <Route path=":slug" element={<TopicPage />} />
        </Route>

        <Route path="/collections">
          <Route index element={<Navigate to="/" />} />
          <Route path=":id/:collect_title" element={<CollectionPage />} />
        </Route>

        <Route path="*" element={<Navigate to="/" />} />
      </Routes>

      {previousLocation && (
        <Routes>
          <Route
            path="/photos/:id"
            element={
              <Modal>
                <PhotoItem />
              </Modal>
            }
          />
        </Routes>
      )}
    </div>
  )
}

export default App
